﻿export class CounterComponent {
    constructor(currentPlan) {
        const self = this;

        self.currentPlanInfo = currentPlan;

        self.SELECTORS = {
            counterSelector: '.declarations-box',
            counterTextSlector: '.declarations-box__text',
            remainingGenerationsSelector: '.js-declarations-current',
            totoalGenerationsSelector: '.js-declarations-total'
        }
        
        self.counterDomWrapper = document.querySelector(`${self.SELECTORS.counterSelector}`);
        if (self.counterDomWrapper) {
            self.counterDom = self.counterDomWrapper.querySelector(`${self.SELECTORS.counterTextSlector}`);
            self.remainingGenerationsDom = self.counterDom.querySelector(`${self.SELECTORS.remainingGenerationsSelector}`);
            self.totalGenerationsDom = self.counterDom.querySelector(`${self.SELECTORS.totoalGenerationsSelector}`);
        } else {
            console.warn('Element not found for counterSelector:', self.SELECTORS.counterSelector);
        }
    }

    async initialize() {
        return new Promise((resolve) => setTimeout(resolve, 100));
    }

    updateCounter(currentPlanInfo) {
        const self = this;
        const conversions = currentPlanInfo.conversions;
        const remainingConversions = currentPlanInfo.remainingConversions;
        self.remainingGenerationsDom.innerHTML = remainingConversions;
        self.totalGenerationsDom.innerHTML = conversions;
        self.counterDomWrapper.classList.remove('d-none');
    }
}